export const ITINERARY_STATUS = {
  ATIVO: 1,
  INATIVO: 2,
};
